import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BeakerAnimation } from './BeakerAnimation';
import { useLoading } from '../../hooks/useLoading';

export function LoadingScreen() {
  const { isLoading } = useLoading();

  return (
    <AnimatePresence>
      {isLoading && (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-black z-50 flex items-center justify-center"
        >
          <motion.div
            className="text-center px-6"
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.3 }}
          >
            <BeakerAnimation />
            <p className="mt-10 text-white/80 text-lg sm:text-xl font-medium tracking-wide">
              Loading our Ambassador
            </p>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
